import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables';

export const RegistrationTrackingReport = async (period) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `MHL_Reports/RegistrationTrackingReport?period=${period}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const DownloadRegistrationTrackingReport = async (period, partnerCode) => {
    const result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `MHL_Reports/DownloadRegistrationTrackingReport?period=${period}&partner_code=${partnerCode}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}